import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <div className='footer-container'>
      <small class='website-rights'>EventHUB © 2022</small>
    </div>
  );
}

export default Footer;